import React from "react";
import {
  Layout,
  Container,
  TitleContainer,
} from "../../style/Home/HomeBanner.module.js";

export const HomeBanner = () => {
  return (
    <Layout>
      <Container>
        <TitleContainer>
          <div>돈 아끼는 면세쇼핑, AI와 함께 </div>
          {/* <div>AI와 함께, 레츠고</div> */}
        </TitleContainer>
      </Container>
    </Layout>
  );
};
